import type { Option } from '@autobid/strapi-integration/typescript/webapi/Dictionary'
import { computed, onServerPrefetch } from 'vue'
import { VEHICLE_TYPE_KEY } from '../../constants/VEHICLE_TYPE_KEY'
import { useNoFilterCounters } from '../car/data/useNoFilterCounters'

interface Ids {
  typeId: string
  categoryId: string
}

export function useCategoriesToDisplay(categories: Omit<Option, 'types'>[]) {
  const { data: noFilterMetadata, suspense } = useNoFilterCounters('auction')
  onServerPrefetch(suspense)

  const ids = computed(() => {
    return categories.reduce((acc: Record<string, Ids>, category) => {
      const [typeId, categoryId] = String(category.id).split(';')
      acc[category.id] = { typeId, categoryId }

      return acc
    }, {})
  })
  const typeId = Object.values(ids.value)?.[0]?.typeId
  const categoriesToDisplay = computed(() => {
    return categories.filter(
      category =>
        noFilterMetadata.value?.counters?.[VEHICLE_TYPE_KEY]?.[
          ids.value[category.id].typeId
        ]?.category[ids.value[category.id].categoryId],
    )
  })

  return { categoriesToDisplay, ids, typeId }
}
